//
// accept: set for file input, to restrict file types accepted
// examples:
// "image/*,.pdf"
// ".doc,.docx,.xml,application/msword"
//
// event returned by fileOnInput is:
// event.target.files = [{
//   name,
//   lastModified,
//   lastModifiedDate,
//   size,
// },
// ...]
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useState } from 'react';

const ColorCircleButton = function ColorCircleButton(props) {
  const {
    onClick,
    disabled,
    id,
    name,
    color,
    dark,
  } = props;
  const [animate, setAnimate] = useState(false);

  const finalClassName = classNames(
    'shrink-0 rounded-full w-7 h-7 p-0.5',
    {
      'border-2 border-pxPrimary cursor-pointer': !disabled,
      'border border-pxOutlineStrong/80': disabled,
      'opacity-50': disabled,
      'bg-black': dark,
      'bg-white': !dark,
    },
    // className,
  );

  return (
    <button
      type="button"
      className={finalClassName}
      disabled={disabled}
      id={id}
      name={name}
      onClick={(event) => {
        setAnimate(true);
        onClick(event);
      }}
    >
      <div
        className={classNames(
          'rounded-full h-full w-full',
          {
            'animate-ripple': animate,
          },
        )}
        style={{
          background: color,
        }}
        onAnimationEnd={() => {
          setAnimate(false);
        }}
      />
    </button>
  );
};

ColorCircleButton.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  name: PropTypes.string,
  color: PropTypes.string,
  dark: PropTypes.bool,
};

export default ColorCircleButton;
